import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsWorkloadPieRoute: InvariantJiraRoute = {
	name: 'legacy-reports-workload-pie-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.ext.charting:workloadpie-report'],
};
